import React from "react";
import { useRef } from "react";
import CircularProgressBar from "../../../../utils/CircularProgressBar";
import Assets from "../../../Layouts/Assets";
import Icon from "../../../Layouts/Icons";
import Style from "./ImageUploadItem.module.scss";
import { useItemProgressListener } from "@rpldy/uploady";

const ImageUploadItem = ({ image, index, uploadIndex, percentage }) => {
  const nameRef = useRef();
  const { completed } = useItemProgressListener(image?.id) || { completed: 0 };

  return (
    <li key={index} className={Style.ImageUploadItem}>
      <div className={Style.ImageUploadItem__imageData}>
        <figure
          className={`${Style.ImageUploadItem__thumbnail} ${
            !image?.batchId ? Style.hasImage : ""
          }`}
        >
          <img
            src={image?.batchId ? Assets?.image_thumb : image?.src}
            alt="img-thumb"
          />
        </figure>
        <span className={Style.ImageUploadItem__name} ref={nameRef}>
          {image?.orginal_name ??
            image?.name ??
            image?.file?.name ??
            image?.result?.result?.image?.original_name}
        </span>
      </div>
      <div
        className={`${Style.ImageUploadItem__progress} ${
          !image?.batchId ? Style.imageUploaded : ""
        }`}
      >
        {image?.batchId ? (
          <CircularProgressBar
            strokeWidth="4"
            sqSize="22"
            percentage={completed}
          />
        ) : (
          <span className={`form-check-box checked`}>
            <Icon color={"#fff"} size={13} icon={"icon-tick"} />
          </span>
        )}
      </div>
    </li>
  );
};

export default ImageUploadItem;
